import { createSelector } from 'reselect';
import dayjs from 'utils/dayjs';
import {
  YEAR_CHART_DATE_FORMAT,
  DEFAULT_CHART_DATE_FORMAT,
  TODAY_CHART_DATE_FORMAT,
  formatParsedDate,
} from 'utils';

export const getRatesGraph = state => state.ratesGraph;

export const getRatesGraphParams = (state, params) => params;

export const makeGetRatesGraphByKeys = () =>
  createSelector(
    getRatesGraph,
    getRatesGraphParams,
    (rates, { sourceCurrency, targetCurrency, period, requestType }) => {
      return rates?.[requestType]?.[`${sourceCurrency}-${targetCurrency}`]?.[
        period
      ];
    }
  );

export const makeGetRatesGraphIsFetching = () => {
  const getRatesGraphByKeys = makeGetRatesGraphByKeys();

  return createSelector(getRatesGraphByKeys, rates => {
    return rates?.isFetching || false;
  });
};

export const makeGetRatesGraphIsInitialized = () => {
  const getRatesGraphByKeys = makeGetRatesGraphByKeys();

  return createSelector(
    getRatesGraphByKeys,
    rates => rates?.isInitialized || false
  );
};

export const makeGetRatesGraphItems = () => {
  const getRatesGraphByKeys = makeGetRatesGraphByKeys();
  return createSelector(getRatesGraphByKeys, rates => {
    return (rates?.ids || []).map(id => {
      return rates.entities[id];
    });
  });
};

export const getRatesGraphItems = makeGetRatesGraphItems();

export const getRatesGraphTimeLine = createSelector(
  getRatesGraphItems,
  getRatesGraphParams,
  (ratesItems, { period, locale }) => {
    return {
      list: ratesItems.map(({ date, time }) => {
        if (period === 'day') {
          return time
            ? dayjs(time, 'HH:mm:ss').format(TODAY_CHART_DATE_FORMAT)
            : formatParsedDate(date, TODAY_CHART_DATE_FORMAT);
        }

        const chartDateFormat =
          period === 'max' ? YEAR_CHART_DATE_FORMAT : DEFAULT_CHART_DATE_FORMAT;

        return formatParsedDate(date, chartDateFormat, locale);
      }),
      from: ratesItems[0],
      to: ratesItems[ratesItems.length - 1],
    };
  }
);

export const getRatesMatrix = createSelector(getRatesGraphItems, ratesItems => {
  const items = {
    auction: { sell: [], buy: [] },
    banks: { sell: [], buy: [] },
    interbank: { sell: [], buy: [] },
    exchangers: { sell: [], buy: [] },
    nbu: {
      rate: [],
    },
    cards: { sell: [], buy: [] },
  };

  ratesItems.forEach(item => {
    Object.keys(items).forEach(type => {
      Object.keys(items[type]).forEach(key => {
        let convertedKey = key;
        if (key === 'sell') {
          convertedKey = 'ask';
        }
        if (key === 'buy') {
          convertedKey = 'bid';
        }
        let course;

        if (type === 'cards') {
          course = item.course ? item.course[convertedKey] : undefined;
        } else if (item.course) {
          course = item.course[type]
            ? item.course[type][convertedKey]
            : undefined;
        } else {
          course = item ? item[convertedKey] : undefined;
        }

        items[type][key].push(course);
      });
    });
  });

  return items;
});
